import { Action } from "../../store/types";
import { Customer } from "../../models";
import * as actions from "./actions";

// Should match any random JWT actually
export interface LoginToken {
  iss: string;
  iat: number;
  exp: number;
  nbf: number;
  jti: string;
  sub: number;
  [customClaimName: string]: any;
}

export interface AuthState {
  tokenRefreshing: boolean;
  token?: string;
  tokenPayload?: LoginToken;
  customer?: Customer;
}

const initState: AuthState = {
  tokenRefreshing: false,
};

export default function(state = initState, { type, payload }: Action) {
  switch (type) {
    case actions.SAVE_TOKEN:
      return { ...state, ...payload };
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/routes/Auth/reducer.ts